module.exports = __webpack_public_path__ + "static/media/verified.ec4b5e62.svg";